import { render } from "./TccDocsDownloads.vue?vue&type=template&id=708784d0&scoped=true"
import script from "./TccDocsDownloads.vue?vue&type=script&lang=js"
export * from "./TccDocsDownloads.vue?vue&type=script&lang=js"

import "./TccDocsDownloads.vue?vue&type=style&index=0&id=708784d0&lang=scss&scoped=true"

import exportComponent from "C:\\Projects\\fxhub-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-708784d0"]])

export default __exports__